/* eslint max-classes-per-file: 0 */

import {
  PublicationStorageFileHistory as Data,
  PublicationStorageFileHistoryCollection as Collection,
} from '@/typings/api/Publication'
import { PublicationsStorageFilesHistoryApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class PublicationStorageFilesHistoryTransformerParams extends TransformerParams {
  protected defaultParams = ['publication_id', 'storage_id'];
}

export class PublicationsStorageFilesHistoryAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new PublicationStorageFilesHistoryTransformerParams();
}
